import { createAction } from '../../../store.model';
import { View } from '../enum/view.enum';
import { ActionType } from '../transcript-dialog.action';

export interface SwitchView {
    view: View;
}

export const switchView = createAction<ActionType, SwitchView>(
    ActionType.COACHING_DETAIL__TD__SWITCH_VIEW,
);
